document.addEventListener('DOMContentLoaded', () => {
  const tagElements = document.querySelectorAll('.blog-tag');
  const currentUrl = new URL(window.location.href);
  const pathSegments = currentUrl.pathname.split('/');

  // Extract the blog page name dynamically
  const pageName = pathSegments[2] || ''; // Assuming the blog page name is the second segment

  // Extract existing tags from the URL
  let selectedTags = [];
  if (pathSegments.includes('tagged')) {
    const tagsSegment = pathSegments[pathSegments.indexOf('tagged') + 1];
    selectedTags = tagsSegment.split('+');
  }

  // Highlight pre-selected tags
  tagElements.forEach(tagElement => {
    if (selectedTags.includes(tagElement.dataset.tag)) {
      tagElement.classList.add('selected');
    }
  });

  tagElements.forEach(tagElement => {
    tagElement.addEventListener('click', () => {
      const tag = tagElement.dataset.tag;

      // Toggle selection
      if (selectedTags.includes(tag)) {
        tagElement.classList.remove('selected');
        selectedTags = selectedTags.filter(t => t !== tag);
      } else {
        tagElement.classList.add('selected');
        selectedTags.push(tag);
      }

      // Update the URL based on the selected tags
      let newUrl;
      if (selectedTags.length > 0) {
        newUrl = `/blogs/${pageName}/tagged/${selectedTags.join('+')}`;
      } else {
        newUrl = `/blogs/${pageName}`; // Default to base blog URL for the current page
      }

      // Navigate to the new URL
      window.location.href = newUrl;
    });
  });
});
